import React, { useState } from "react";
import { Panel, TextBox, Label, Spinner, useDataContext } from "lib/components";
import PanelCustomerOrderDetail from "./PanelCustomerOrderDetail";
import { getDataFromContext } from "lib/util/ModelUtil";

export function PanelCustomerOrderFullDetail({data, unauthenticated=false, searchQueryString="", ...props}) {
	let modelName;
	if (unauthenticated)
		modelName =`ar/customer-orders-unauthenticated${searchQueryString}`;
	let [loading, setLoading] = useState(false);
	return (
		<Panel modelName={modelName} data={data} setLoading={setLoading} autoSearch={unauthenticated}>
			<Detail unauthenticated={unauthenticated} loading={loading}/>		
		</Panel>
	);
}

function Detail({unauthenticated, loading}) {
	let context = useDataContext();
	if (!context || context.list == null || context.list.length !== 1) {
		if (loading)
			return <Spinner />
		return (
			<Panel >
				<Label caption="No orders found." fontBold fontSize="xlarge"/>
			</Panel>
		);
	}
	let data = getDataFromContext(context);
	if (data != null && data.error) {
		return (
			<Panel >
				<Label caption={data.error} fontBold fontSize="xlarge"/>
			</Panel>
		);
	}
	let detailFieldName;
	if (unauthenticated)
		detailFieldName = "detail";
	return (
		<Panel textBoxVariant="label" fillRow>
			<Panel fillRow >
				<Label caption="Order" fontBold fontSize="xlarge" visible={unauthenticated} noRowBreak/>
				<Label fieldName="orders.id" fontBold fontSize="xlarge" visible={unauthenticated} />
				<TextBox caption="BOL number" fieldName="orders.blnum" fillRow noRowBreak nullDisplayValue="N/A"/>
				<TextBox caption="Status" fieldName="status_descr" fillRow noRowBreak />
				<TextBox caption="Ship date" fieldName="shipper.sched_arrive_early" displayType="datetime" format="long" fillRow noRowBreak />
				<TextBox caption="Shipper city" fieldName="shipper.city_name" fillRow noRowBreak />
				<TextBox caption="Shipper state" fieldName="shipper.state" fillRow noRowBreak />
				<TextBox caption="Consignee city" fieldName="consignee.city_name" fillRow noRowBreak />
				<TextBox caption="Consignee state" fieldName="consignee.state" fillRow noRowBreak/>
				<TextBox caption="Consignee ref number" fieldName="orders.consignee_refno" nullDisplayValue="N/A" />
			</Panel>
			<PanelCustomerOrderDetail fieldName={detailFieldName} unauthenticated={unauthenticated} fillRow />
		</Panel>
	);			
}